import { useContext } from 'react';
import { VideoRecordingContext } from './videoRecordingContext';

export const useVideoRecordingContext = () => {
  const context = useContext(VideoRecordingContext);
  if (!context) {
    throw new Error(
      'useVideoRecordingContext must be used within a VideoRecordingProvider'
    );
  }
  return context;
};
